import axios from 'axios';

// let base = 'https://www.madridshop.cc/wp-json/wp/v2';
// let base = 'https://f0j48xos.directus.app/items';
//let base = 'http://127.0.0.1:4000';
// let base = 'http://192.53.120.45:4000/';
let base = 'https://hy2022.top';
//let base1 = 'https://oxaxd.com.cn';
//let base1 = 'https://mpaytab.top';
let base1 = 'https://mpayerp.top';
//let base1 = 'https://mpaytab.shop';
// let url_ = 'https://api.51tracking.com';

// 查询订单列表
export const getOrder = sc => {
    return axios.get(`${base}/getorderlist/${sc}`).then(res => res.data);
}

// 获取 物流列表
export const getWl = async params => {
    const res = await axios.post(`${base}/getwl_list`,params);
    return res.data;
}

// 操作分页获取 订单列表
export const getOrder_ = async params => {
    const res = await axios.post(`${base}/getOL`, params);
    return res.data;
}

// 获取 订单列表 总条数
export const getOrderPage = async params => {
    const res = await axios.post(`${base1}/index/erporder`, params);
    return res.data;
}

// 操作分页获取 商品列表
export const getProductList = async params => {
    const res = await axios.post(`${base1}/index/erporder/getPL`, params);
    return res.data;
}

// 获取 商品列表 总条数 getPLPage
export const getProductPage = async params => {
    const res = await axios.post(`${base1}/index/erporder/getPLPage`, params);
    return res.data;
}

// 通过(订单id,商品id,国际物流单号,商品名称,字号)获取商品列表
export const getProduct = cs => {
    return axios.get(`${base}/getproductlist/${cs}`).then(res => res.data);
}

// 批量搜索(通过商品id)
export const pilss = async params => {
    const res = await axios.post(`${base}/getplss`, params);
    return res.data;
}

// 通过 国际物流单号 搜索 物流轨迹
export const sswlgj = async cs => {
    const res = await axios.get(`${base}/getwlgj/${cs}`);
    return res.data;
}

//通过 site和订单id 获取单个订单里的一个或多个商品
export const getProduct_ = params => {
    return axios.post(`${base}/getLP`,params).then(res => res.data);
}

// 通过 id主键 获取单个订单详情
export const getOD = async id => {
    const res = await axios.get(`${base}/getorderlist/${id}`);
    return res.data;
}

// 通过 site和订单id 获取单个订单详情
export const getOD_ = async params => {
    const res = await axios.post(`${base}/getODlist`, params);
    return res.data;
}
// 通过postcode 判断渠道
export const postcode = async params => {
    const res = await axios.post(`${base}/postcode`, params);
    return res.data;
}
// 修改单个订单
export const updateOD = id => {
    return axios.get(`${base}/updateorderlist/${id}`).then(res => res.data);
}

// 编辑国际物流单号
export const editIntNo = params => {
    return axios.post(`${base}/editintno`,params).then(res => res.data);
}

//编辑 商品名称 || 客服备注 || 仓库备注 || 物流备注 || 国内快递单号 || 商品状态 || 袖标 || 配件 || 字号
export const Edit = params => {
    return axios.post(`${base}/productlist`,params).then(res => res.data);
}

//导出的订单改变商品状态
export const DC = async params => {
    const res = await axios.post(`${base}/exportProductList`, params);
    return res.data;
}

//发货按钮
export const Send = params => {
    // return axios.post(`http://193.112.209.104:8082/createOrderApi.htm`,params).then(res => res.data);
    // return axios.post(`/api/createOrderApi.htm`,params).then(res => res.data);
    return axios.post(`${base}/createOrderApi`,params).then(res => res.data);
    // return axios.post(`https://webhook.site/21d86a73-d65e-4a16-931b-9f28b7416b73`,params).then(res => {});
}

//发货(新)世通
export const Send_ = async params => {
    const res = await axios.post(`${base}/createOrderApi_`, params);
    return res.data;
}

//发货(新)威速易
export const Send_wsy = async params => {
    const res = await axios.post(`${base}/createOrderApi_wsy`, params);
    return res.data;
}

//发货(新)鑫佰航
export const Send_xbh = async params => {
    const res = await axios.post(`${base}/createOrderApi_xbh`, params);
    return res.data;
}


//发货海贝通
export const Send_hbt = async params => {
    const res = await axios.post(`${base}/createOrderApi_hbt`, params);
    return res.data;
}

//获取某种特定状态的所有商品
export const getPT = () => {
    return axios.get(`${base}/PT`).then(res => res.data);
}

//批量操作修改物流商
export const plczwls = async params => {
    const res = await axios.post(`${base}/wls`, params);
    return res.data;
}

// 补单
export const BD_ = async params => {
    const res = await axios.post(`${base}/replenish`, params);
    return res.data;
}

// 查询物流列表
// export const cxwl = async () => {
//     const res = await axios.get(`${base}/getwl`);
//     return res.data;
// }

// 把用户操作记录写入 log_list 表
export const czjl = async params => {
    const res = await axios.put(`${base}/addUserLog`,params);
    return res.data;
}

// 查询 操作记录 表
export const cxcz = async () => {
    const res = await axios.get(`${base}/getLog`);
    return res.data;
}

// 修改状态记录加入 Loglist
export const changeProductStatus = async params => {
    const res = await axios.put(`${base}/newLog`,params);
    return res.data;
}

// 获取 Loglist 的记录
export const hqjl = async params => {
    const res = await axios.post(`${base}/hqjl`,params);
    return res.data;
}

// 获取 待发货-制作中 的商品对应的时间
export const hqsj = async params =>{
    const res = await axios.post(`${base}/getSJ`,params);
    return res.data;
}

// 获取 正在处理 的订单 getzzcl
export const hqzzcl = async () => {
    const res = await axios.get(`${base1}/index/erporder/counts`);
    return res.data;
}

// 获取所有product_list
export const GPL = async () => {
    const res = await axios.get(`${base}/GPL`);
    return res.data;
}

// 仓库点击表格录入商品采购价
export const ckpllrspcgj = async params => {
    const res = await axios.post(`${base}/lrcgj`,params);
    return res.data;
}

// 主账号修改是否加急订单
export const ChangeSpeed = async params => {
    const res = await axios.post(`${base}/ChangeSpeed`,params);
    return res.data;
}

// 上传sku
export const UploadSku = async params => {
    const res = await axios.post(`${base}/UploadSku`,params);
    return res.data;
}

// 删除sku(修改显示或隐藏标志)
export const DeleteSku = async params => {
    const res = await axios.post(`${base}/DeleteSku`,params);
    return res.data;
}

// 优先添加SKU(修改隐性时间和是否优先状态)
export const PriorityAddSku = async params => {
    const res = await axios.post(`${base}/PriorityAddSku`,params);
    return res.data;
}

// 查询SKU
export const SearchSku = async params => {
    const res = await axios.post(`${base}/SearchSku`,params);
    return res.data;
}

// 获取所有flag=1的SKU(hidden_time DESC)
export const GetSku = async () => {
    const res = await axios.get(`${base}/GetSku`);
    return res.data;
}

// 修改站点SKU添加情况
export const EditSite = async params => {
    const res = await axios.post(`${base}/EditSite`,params);
    return res.data;
}

// 修改SKU时,根据主键SKU查询出必要的字段进行比较(一致时不修改 不同时调用修改SKU接口)
export const GetKey = async params => {
    const res = await axios.post(`${base}/GetKey`,params);
    return res.data;
}

// 更新 联赛名称、队伍名称、SKU、商品名称、短裤、袜子、备注 其中一项或多项
export const UpdateSku = async params => {
    const res = await axios.post(`${base}/UpdateSku`,params);
    return res.data;
}

// 新增域名
export const AddDomain = async params => {
    const res = await axios.post(`${base}/AddDomain`,params);
    return res.data;
}

// 获取域名
export const GetDomain = async params => {
    const res = await axios.post(`${base}/GetDomain`,params);
    return res.data;
}

// 删除域名
export const DeleteDomain = async params => {
    const res = await axios.post(`${base}/DeleteDomain`,params);
    return res.data;
}

// 获取当前主站的所有关键词和锚文本链接
export const Get_gjc_mwblj = async params => {
    const res = await axios.post(`${base}/Get_gjc_mwblj`,params);
    return res.data;
}

// 编辑域名
export const editDomain = async params => {
    const res = await axios.post(`${base}/editDomain`,params);
    return res.data;
}

// 获取SKU消息状态
export const getIsDot = async params => {
    const res = await axios.post(`${base1}/index/erporder/getIsDot`,params);
    return res.data;
}

// 修改一条SKU消息状态
export const editIsDot = async params => {
    const res = await axios.post(`${base}/editIsDot`,params);
    return res.data;
}

// 获取100条SkuRecord
export const GetSkuRecord = async () => {
    const res = await axios.get(`${base}/GetSkuRecord`);
    return res.data;
}

// 批量获取国际物流单号
export const Plhqgjwldh = async params => {
    const res = await axios.post(`${base}/plhqgjwldh`,params);
    return res.data;
}

// 通过 国际物流单号 或 订单号 查询物流轨迹
// export const getwl = async cs => {
//     const res = await axios.get(`${base}/getwl_list/${cs}`);
//     return res.data;
// }

// //获取Directus(订单列表)中的数据
// export const getOrder = page => {
//     // return axios.get(`${base}/orderlist/?limit=-1`).then(res => res.data);
//     return axios.get(`${base}/orderlist`, {params:{limit: page}}).then(res => res.data);
// };
// //获取Directus(订单详情)中的某一条数据
// export const getOD = id => {
//     return axios.get(`${base}/orderdetail/${id}`).then(res => res.data);
// };
// //获取Directus(订单详情)中的所有数据
// export const getAllOD = () => {
//     return axios.get(`${base}/orderdetail`).then(res => res.data);
// };
// //新增Directus(订单列表)中的数据
// export const newAdd = params => {
//     return axios.post(`${base}/orderlist`, params).then(res => res.data);
// };
// //新增Directus(订单详情)中的数据
// export const newAdd_ = params => {
//     return axios.post(`${base}/orderdetail`, params).then(res => res.data);
// };

// //获取文章列表
// export const getArticleList = params => {
//     return axios.get(`${base}/posts`, params).then();
// };
// //获取单篇文章
// export const getArticle = ids => {
//     return axios.get(`${base}/posts/${ids}`).then(res => res.data);
// };
// //获取文章分类
// export const getCategories= params => {
//     return axios.get(`${base}/categories`, params).then(res => res.data);
// };
// //获取文章作者
// export const getAuthor= ids => {
//     return axios.get(`${base}/users/${ids}`).then(res => res.data);
// };